"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TripOutput = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const account_output_1 = require("../account.output");
const panel_vars_output_1 = require("../panel-vars.output");
const passenger_output_1 = require("../passenger.output");
const user_output_1 = require("../user.output");
const transport_output_1 = require("./transport.output");
const trip_driver_output_1 = require("./trip-driver.output");
const trip_resume_output_1 = require("./trip-resume.output");
const trip_vars_output_1 = require("./trip-vars.output");
const trip_claim_output_1 = require("./trip-claim.output");
const price_and_condition_output_1 = require("../../../pricing/output/price-and-condition.output");
const trip_driver_timing_output_1 = require("./trip-driver-timing.output");
class TripOutput {
}
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TripOutput.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TripOutput.prototype, "key", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], TripOutput.prototype, "clusterId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsEnum)(['INCOMING', 'ONDUTY', 'ONPAYMENT', 'DONE', 'CANCELLED']),
    __metadata("design:type", String)
], TripOutput.prototype, "state", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TripOutput.prototype, "readableState", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], TripOutput.prototype, "attributedBy", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], TripOutput.prototype, "attributionMode", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsEnum)([
        'STANDBY_BEFORE_APPROACH_INCOMING',
        'IN_APPROACH_INCOMING',
        'IN_PLACE_INCOMING',
        'PICKED_UP_STARTED',
        'ADMIN_CANCELLATION',
        'PASSENGER_CANCELLATION',
        'DRIVER_NO_SHOW_CANCELLATION',
        'PASSENGER_NO_SHOW_CANCELLATION',
        'DROPPED_OFF_TERMINATED',
        'WAITING_FOR_PAYEMENT',
    ]),
    __metadata("design:type", String)
], TripOutput.prototype, "subState", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", trip_resume_output_1.TripResumeOutput)
], TripOutput.prototype, "resume", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", trip_vars_output_1.TripVarsOutput)
], TripOutput.prototype, "tripVars", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", passenger_output_1.PassengerOutput)
], TripOutput.prototype, "passenger", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Type)(() => passenger_output_1.PassengerOutput),
    __metadata("design:type", Array)
], TripOutput.prototype, "otherPassengers", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", user_output_1.UserOutput)
], TripOutput.prototype, "booker", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", account_output_1.AccountOutput)
], TripOutput.prototype, "account", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", trip_driver_output_1.TripDriverOutput)
], TripOutput.prototype, "driver", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", panel_vars_output_1.PanelVarsOutput)
], TripOutput.prototype, "panelVars", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TripOutput.prototype, "oldPriceAndConditionKey", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", price_and_condition_output_1.PriceAndConditionOutput)
], TripOutput.prototype, "latestPriceAndCondition", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", transport_output_1.TransportOutput)
], TripOutput.prototype, "transport", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", trip_claim_output_1.TripClaimOutput)
], TripOutput.prototype, "claim", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", trip_driver_timing_output_1.TripDriverTimingOutput)
], TripOutput.prototype, "driverTiming", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], TripOutput.prototype, "etaBeforeDriverAssignment", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TripOutput.prototype, "packageId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TripOutput.prototype, "groupId", void 0);
exports.TripOutput = TripOutput;
